import { useEffect, useState } from 'react'

import { HelperText } from '@componentes-mu/componentes-mu'

import styles from './styles.module.scss'

export type InputTextAreaProps = {
  id?: string
  valor?: string
  variante?: 'regular' | 'success' | 'error'
  desabilitado?: boolean
  placeholder?: string
  onChange: (value: string) => void
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
  onKeyUp?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onSubmit?: (value: string) => void
  error?: boolean;
  infoText?: string;
}

const InputTextArea = ({
  id,
  valor,
  placeholder = 'Descreva com o máximo de detalhes sua dúvida ou problema encontrado',
  desabilitado = false,
  error = false,
  infoText,
  onChange,
  onKeyUp,
  onKeyDown,
  onFocus,
  onSubmit,
}: InputTextAreaProps) => {
  const [inputValue, setInputValue] = useState(valor ?? '')

  useEffect(() => {
    setInputValue(valor ?? '');
  }, [valor]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value)
    setInputValue(event.target.value)
  }

  return <div className={styles.textAreaContainer}>
    <div >
      <textarea
        className={`${error ? styles.inputTextAreaError : ''}`}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (onKeyDown) onKeyDown(e)
          if (e.key === 'Enter' && onSubmit) onSubmit(inputValue)
        }}
        disabled={desabilitado ? true : false}
        placeholder={placeholder}
        name={id}
        id={id}
        value={inputValue}
        onKeyUp={onKeyUp}
        onFocus={onFocus}
      />
    </div>
    {error && infoText && (
      <HelperText
        texto={infoText}
        estado={error ? "error" : "regular"}
      />
    )}
  </div>
}
export { InputTextArea }
